import React, { createContext } from 'react';

const DashboardsContext = createContext();

export default DashboardsContext;
